import { useTranslation } from 'react-i18next';

import useNotifications from 'hooks/common/useNotifications';

import { GoogleCaptchaErrorType, ErrorMessages, RequestErrorMessages } from 'constants/errors';

interface IGoogleCaptchaHandlerHook {
  setError: (error: string) => void;
}

const useGoogleCaptchaHandler = ({ setError }: IGoogleCaptchaHandlerHook) => {
  const { t } = useTranslation();
  const { notificationApi } = useNotifications();

  const onCaptchaError = captchaError => {
    switch (captchaError) {
      case GoogleCaptchaErrorType.COMPLETELY_FAILED: {
        setError(captchaError);

        notificationApi.error({ title: t(RequestErrorMessages[captchaError] || ErrorMessages.COMMON.UNKNOWN) });
        return;
      }

      case GoogleCaptchaErrorType.FIRST_STEP_FAILED:
      default: {
        setError(null);
        return;
      }
    }
  };

  return { onCaptchaError };
};

export default useGoogleCaptchaHandler;
